'use strict'

import ApiClient from './ApiClient'

export default class NewBcardRepository {
  // TODO 共通化
  setMgmtParam (isMgmt, params) {
    params = params || {}

    if (isMgmt) {
      params.is_mgmt = '1' // TODO this.app_flag.ON
    }

    return params
  }

  /**
   * 名刺情報の作成
   * @param formData 登録データ
   * @returns {*}
   */
  post (formData) {
    return ApiClient().post(`/bcard-entries`, formData, {
      headers: ApiClient().getFormHeaders(formData)
    })
  }

  // /**
  //  * 画像からの登録状況一覧からの取得
  //  * @param {object} params
  //  * @returns {*}
  //  */
  // getBcardImages (params) {
  //   return ApiClient().get(`/bcard-images`, { params })
  // }

  // /**
  //  * 指定された複数名刺IDの画像からの登録状況情報を一括削除します。
  //  * @param {object} params
  //  * @returns {*}
  //  */
  // bulkDeleteBcardImages (params) {
  //   return ApiClient().post(`/bcard-images/delete`, params)
  // }

  /**
   * CSVファイルからの登録状況一覧を取得
   * @param {object} params
   * @returns {*}
   */
  getBcardCsvs (params) {
    return ApiClient().get(`/bcard-csvs`, { params })
  }

  /**
   * 名刺情報のCSVファイルをアップロード
   * @param {object} formData
   * @param {bool} isMgmt 管理モードフラグ
   * @returns {*}
   */
  postBcardCsvs (formData, isMgmt) {
    // 名刺管理の場合は、管理モードフラグを付ける
    return ApiClient().post(`/bcard-csvs`, formData, {
      headers: {'Content-Type': 'multipart/form-data'},
      params: this.setMgmtParam(isMgmt)
    })
  }

  /**
   * 指定された複数IDのCSVからの登録状況情報を一括削除します。
   * @param {object} params
   *    - {array} ids 登録状況IDの配列
   *    - {bool} isMgmt 管理モードフラグ
   * @returns {*}
   */
  bulkDeleteBcardCsvs (params) {
    return ApiClient().post(
      `/bcard-csvs/delete`,
      { id: params.id },
      { params: this.setMgmtParam(params.isMgmt) }
    )
  }

  /**
   * アップロードの処理結果を取得
   * @param isMgmt 管理モードフラグ
   * @returns {*}
   */
  getBcardCsvsUploadResult (isMgmt) {
    // 名刺管理の場合は、管理モードフラグを付ける
    const params = this.setMgmtParam(isMgmt)
    return ApiClient().get(`/bcard-csvs/upload-result`, { params })
  }

  // /**
  //  * 最新の名刺情報を取得する
  //  * @param {string|int} id 人物ID
  //  * @param {bool} isMgmt 管理モードフラグ
  //  * @returns {*}
  //  */
  // getLatestBcard (id, isMgmt) {
  //   // 名刺管理の場合は、管理モードフラグを付ける
  //   const params = this.setMgmtParam(isMgmt)
  //   // (TODO) そのうち/persons/{person_id}/bcards/{bcard_id}に統合されるようなので、その時に対応する
  //   return ApiClient().get(`/persons/${id}/latestbcard`, { params })
  // }
}



// WEBPACK FOOTER //
// ./src/repositories/NewBcardRepository.js